import { FakePageData } from '@4finance/cwt-test-helper';
import { PERSONAL_DETAILS } from 'Router/routes';
import {
  generateBirthNumber,
  generateEmail,
  generateFirstName,
  generateLastName,
  generatePhoneNumber,
} from 'utils/TestHelper/generators/generators';

const personalDetailsScenarios: FakePageData = {
  url: PERSONAL_DETAILS,
  items: {
    'Fill Personal Details': [
      ['#firstName', () => generateFirstName()],
      ['#lastName', () => generateLastName()],
      ['#personalId', () => generateBirthNumber()],
      ['#mobilePhone', () => generatePhoneNumber()],
      ['#email', () => generateEmail()],
      ['#password', 'Password1'],
      ['#acceptAgreement', 'checkbox'],
      ['#acceptProfiling', 'checkbox'],
      ['#acceptNews', 'checkbox'],
      ['#acceptFaceIdProcessing', 'checkbox'],
      ['[data-test="submit_btn_basics"][type="submit"]', 'submit-button'],
    ],
  },
};

export { personalDetailsScenarios };
